export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const KEY = `52a7c050-a63d-4391-a402-419e9b1ff990`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
